<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-03 20:00:12
 * @LastEditors: jing
 * @LastEditTime: 2020-12-11 17:46:12
 * @Description: file content
 -->

<template>
  <div class="container">
    <div :class="[{ loaded: showAnimate }]">
      <loading></loading>
    </div>
    <div class="tabCalculator" v-if="showAnimate">
      <div class="video_list">
        <div
          class="video_item"
          @click="clickVideo(item)"
          v-for="(item, index) in result"
          :key="index"
        >
          <div
            class="video_content"
            :style="{ backgroundImage: 'url(' + item.main_img + ')' }"
          >
            <!-- <div class="times-wrap">
            <div class="triangle"></div>
            <div class="times-text">{{ item.times }}次</div>
          </div> -->
          </div>
          <!-- <div class="video_title"></div> -->
          <div class="video_title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <Tabbar12 :seleIndex="0"></Tabbar12>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
const loading = () => import("./loading");
const Tabbar12 = () => import("@/components/tabbar12");
import { videoList } from "../config";

export default {
  components: {
    loading,
    Tabbar12
  },
  props: {},
  data() {
    return {
      result: [],
      showAnimate: false
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "userInfo",
      "pageInfo",
      "shareSpreadInfo",
      "isInMiniProgram",
      "receiveSpreadInfo"
    ])
  },
  methods: {
    clickVideo(item) {
      this.$router.push(
        `/vcard3/video?videoId=${item.id}&entry=${this.$route.query.entry}&id=${
          this.$route.query.id
        }&psn=${this.$route.query.psn}&saleropenid=${
          this.$route.query.saleropenid
        }&backhome=home&t9id=${this.$route.query.t9id}&t9psn=${
          this.$route.query.t9psn
        }`
      );
    },
    setShareInfo() {
      util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
        let saleropenid = this.$route.query.saleropenid;
        if (this.global.isLoc && !saleropenid) {
          saleropenid = this.$openid;
        }
        comreq.getUserInfoAndFansInfo(saleropenid).then(data => {
          this.cardUserInfo = data;
          console.log("销售信息", JSON.parse(JSON.stringify(data)));
          this.cardUserInfo.ui.name
            ? (document.title = `中海·映山湖-${
                this.cardUserInfo.ui.name
              }的电子名片`)
            : "";
          util.setFoundShareCustomPageName(
            `我是${this.cardUserInfo.ui.name}，欢迎您随时联系`,
            `手机号：${this.cardUserInfo.ui.mobile} ${
              this.cardUserInfo.ui.wechatno
                ? "微信号：" + this.cardUserInfo.ui.wechatno
                : ""
            }`,
            this.pageInfo,
            this.shareSpreadInfo,
            false,
            `&entry=zxslzx&t9id=${this.$route.query.t9id}&t9psn=${
              this.$route.query.t9psn
            }&saleropenid=${saleropenid}&backhome=home`,
            this.cardUserInfo.ui.headimg,
            "vcard3/home"
          );
        });
      });
    },
    setAnimate() {
      setTimeout(() => {
        this.showAnimate = true;
      }, 800);
    }
  },
  created() {
    let currentType = this.$route.query.type;
    console.log(currentType);
    if (currentType == 1) {
      this.result = videoList.gfsf;
    } else if (currentType == 2) {
      this.result = videoList.twsf;
    }
    this.setShareInfo();
    this.setAnimate();
  },
  mounted() {}
};
</script>
<style lang="stylus" scoped>
// px 转换 rem
p2r(designpx) {
  $rem = 100px;
  return (designpx / $rem) rem;
}
.video_list {
  display :flex;
  flex-wrap:wrap;
  margin: 0.3rem 0.15rem;
  overflow: hidden;
  box-sizing:border-box;
}
.video_item{
  display :flex;
  flex-direction :column;
  align-items :center;
  width :50%;
  // height:50px;
  padding:0 0.15rem;
  // background-color:blue;
  box-sizing:border-box;
  margin-bottom: 0.2rem;
}
.video_content{
  width :100%;
  height: 3.5rem;
  // background-color:red;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.video_title{
  color: #2e2e2e;
  margin-top:0.1rem;
}

.times-wrap{
  position:absolute;
  bottom:p2r(10px);
  left:p2r(20px);
  display :flex;
  align-items :center;
}
.triangle{
  width:0;
  height:0;
  border-top:p2r(10px) solid transparent;
  border-bottom:p2r(10px) solid transparent;
  border-left:p2r(10px) solid #fff;
  margin-right:p2r(5px)
}
.times-text{
  font-size: p2r(13px);
  color: #FFFFFF;
}
</style>
